import {request} from "./request";

export function getNoticeList(page,token) {
  return request({
    url: '/note/noteList',
    data:{
      'page':page,
      'pageSize':'10',
    }
  },token)
}export function readNotice(id,token) {
  return request({
    url: '/note/noteRead',
    data: {
      'noteId':id
    }
  },token)
}
